/**
 * 文本
 * @author yuxin.zhang 2018.11.9
 */

import React from 'react';

import { FormType } from '../FormType';

import ItemContext from './ItemContext';
import LeftTitle from './LeftTitle';

export default class ItemRaw extends ItemContext {
  constructor(props) {
    super(props);

    this.state = {
      value: '',
    };
  }

  UNSAFE_componentWillMount() {
    this.setValue(this.props.dataSource);
    this.setValue(this.props.isOptional);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setValue(nextProps.dataSource);
  }

  /**
   * 渲染文本类型
   * @returns {*}
   */
  renderFormLineText() {
    const { value } = this.state;

    return (
      <div
        className="form-input-box"
        style={{ verticalAlign: 'middle', padding: '10px 0' }}
      >
        <span>{value}</span>
      </div>
    );
  }

  render() {
    const { dataSource } = this.props;
    return (
      <div className="form-item">
        <LeftTitle dataSource={dataSource} />
        {this.renderFormLineText()}
      </div>
    );
  }
}

ItemRaw.defaultProps = {
  dataSource: {
    key: '',
    extend: null,
    placeholderRight: null,
    formType: FormType.TEXT,
    inputAttr: {},
    defaultValue: '',
    list: [],
    errorData: [],
    callback: null,
    onChange: null,
    onBlur: null,
    filter: (val) => {
      return val;
    },
  },
};
